import { Component, OnInit, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { svLocale } from 'ngx-bootstrap/locale';

@Component({
  selector: 'bs-datepicker',
  template: `
    <div class="input-group input-group-sm">
      <input
        type="text"
        class="form-control"
        #dp="bsDatepicker"
        bsDatepicker
        [bsConfig]="bsConfig"
        [bsValue]="bsValue"
        (bsValueChange)="onValueChange($event)"
        [disabled]="disabled"
      />
      <span class="input-group-btn">
        <button
          class="btn btn-default"
          type="button"
          (click)="dp.toggle()"
          [attr.aria-expanded]="dp.isOpen"
          [disabled]="disabled"
        >
          <i class="fa fa-calendar"></i>
        </button>
      </span>
    </div>
  `,
  styles: [
    `
      .input-group-sm .form-control {
        font-size: 14px;
      }
    `,
  ],
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => BsDatepickerComponent),
      multi: true,
    },
  ],
})
export class BsDatepickerComponent implements OnInit, ControlValueAccessor {
  bsValue = new Date();
  bsConfig = {
    containerClass: 'theme-dark-blue',
    showClear: true,
    showClose: true,
    showTodayButton: true,
    showWeekNumbers: true,
    isAnimated: true,
    locale: 'sv',
    adaptivePosition: true,
    dateInputFormat: 'YYYY [V]WW',
  };
  bsRangeValue: Date[];
  maxDate = new Date();
  minDate = new Date();
  disabled = false;

  private onChange: (value: string) => void = () => {};
  private onTouched: () => void = () => {};

  constructor() {
    // Define Swedish locale
    defineLocale('sv', svLocale);
    //this.minDate.setDate(this.minDate.getDate() - 1);
    //this.maxDate.setDate(this.maxDate.getDate() + 7);
    //this.bsRangeValue = [this.bsValue, this.maxDate];
  }

  ngOnInit(): void {}

  onValueChange(value: Date): void {
    console.log('Date changed:', value);
    this.bsValue = value;
    const dateString = this.dateToString(value);
    this.onChange(dateString);
    this.onTouched();
  }

  // Convert Date to YYYY-MM-DD string
  private dateToString(date: Date): string {
    if (!date) return '';
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  // Convert YYYY-MM-DD string to Date
  private stringToDate(dateString: string): Date | null {
    if (!dateString) return null;
    const parts = dateString.split('-');
    if (parts.length !== 3) return null;
    return new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
  }

  // ControlValueAccessor implementation
  writeValue(value: string): void {
    if (value) {
      const date = this.stringToDate(value);
      if (date) {
        this.bsValue = date;
      }
    }
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
